import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input } from 'semantic-ui-react';
import * as _ from 'lodash';
import shortid from 'shortid';
import PropTypes from 'prop-types';

import { setElementChanged } from 'State/dirtyTracking/actions';
import { InputMode } from 'Common/FormEnum';
import {
  getValueFromInputMode,
  handleModeInputKeyPress,
} from 'Common/GeneralHelper';

class TrackedInputContainer extends Component {
  static propTypes = {
    initialValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    track: PropTypes.bool,
    numericSize: PropTypes.arrayOf(PropTypes.number),
    mode: PropTypes.oneOf(Object.values(InputMode)),
    allowNegative: PropTypes.bool,
  };

  static defaultProps = {
    track: true,
    numericSize: [12, 2],
    allowNegative: false,
  };

  componentDidMount() {
    this.id = shortid.generate();
  }

  onInput = e => {
    const { mode, numericSize } = this.props;

    e.target.value = getValueFromInputMode(mode, numericSize, e.target.value);

    if (this.props.track) {
      this.props.setElementChanged(
        this.id,
        this.props.initialValue,
        e.target.value
      );
    }
  };

  onKeyPress = e => {
    const { mode, allowNegative, onChange } = this.props;
    handleModeInputKeyPress(e, mode, allowNegative, onChange);
  };

  render() {
    const rest = _.omit(this.props, [
      'initialValue',
      'setElementChanged',
      'mode',
      'numericSize',
      'track',
      'allowNegative',
    ]);

    return (
      <Input {...rest} onInput={this.onInput} onKeyPress={this.onKeyPress} />
    );
  }
}

const TrackedInput = connect(null, {
  setElementChanged,
})(TrackedInputContainer);

export { TrackedInput };



// WEBPACK FOOTER //
// ./src/components/tracked/TrackedInput.js